export const tags = [
    'RescaleIntercept',
    'RescaleSlope',
    'RescaleType',
];
